export default __webpack_public_path__ + "static/media/competitions_module-background.2e52f777.jpeg";